import { NgClass, NgStyle } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TilbyGesturesDirective } from "@tilby/tilby-ui-lib/directives/tilby-gestures";
import { TilbyCurrencyPipe } from "@tilby/tilby-ui-lib/pipes/tilby-currency";
import { Categories, Items } from "tilby-models";
import { ShowcaseStockBadgeComponent } from "../showcase-stock-badge";

@Component({
    selector: "app-showcase-list-item-v2",
    templateUrl: "./showcase-list-item-v2.component.html",
    standalone: true,
    imports: [NgClass, NgStyle, MatIconModule, ShowcaseStockBadgeComponent, TilbyCurrencyPipe, TilbyGesturesDirective]
})
export class ShowcaseListItemV2Component {
    private static readonly defaultColor = "BBDEFB";
    static readonly ROW_HEIGHT = 64;

    @Input({ required: true }) item!: Items;
    @Input() itemCategory?: Categories;
    @Input() odd = false;
    @Input() showThumbnail = true;
    @Input() showUnavailableStock = true;
    @Input() priceWithCurrency = true;
    @Input() showPrices = true;
    @Input() showItemIcon = false;
    @Input() fontNameSize = 12;
    @Input() fontPriceSize = 12;
    @Input() priceIdentifier: keyof Items = "price1";
    @Input() getStockStatus: Function = () => {};
    @Output() itemTapped = new EventEmitter<Items>();
    @Output() itemLongPressed = new EventEmitter<Items>();

    protected get accentColor(): string {
        return `#${this.item.color || this.itemCategory?.color || ShowcaseListItemV2Component.defaultColor}`;
    }

    protected get initials(): string {
        return (this.item.name ?? '')
            .split(/\s+/)
            .filter(Boolean)
            .slice(0, 2)
            .map((word) => word[0])
            .join('')
            .toUpperCase();
    }

    protected isStockVisible(status: string): boolean {
        return this.showUnavailableStock || status !== 'stock-info-nostock';
    }
}
